import { Component } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { SecurityService } from "src/app/core/services/security-service";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ProductService } from "src/app/core/services/product-service";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { LogService } from "src/app/core/services/log-service";
import Swal from "sweetalert2";
import "@angular/localize/init";
import { InitProvider } from "src/app/core/services/init-provider";
import { UsuarioService } from "src/app/core/services/usuario-service";
declare var $: any;

@Component({
  selector: "app-page-login",
  templateUrl: "./page-login.component.html",
  styleUrls: ["./page-login.component.css"],
})
export class PageLoginComponent {
  SITE: ConfiguracoesSite;

  public form: FormGroup;
  public error: Boolean = false;
  public form2: FormGroup;
  public error2: Boolean = false;
  public API_IMAGENS: String;
  public imageBackground = 1;
  public registroLogin = false;

  constructor(
    private formBuilder: FormBuilder,
    private securityService: SecurityService,
    public productService: ProductService,
    public usuarioService: UsuarioService,
    public initProvider: InitProvider
  ) {
    this.SITE = Configuracoes.SITE;
    this.API_IMAGENS = Configuracoes.API_IMAGENS;
    this.registroLogin = Configuracoes.MISC.registroLogin;
    this.form = this.formBuilder.group({
      email: ["", Validators.required],
      senha: ["", Validators.required],
    });
    this.form2 = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });
    this.imageBackground = Math.floor(Math.random() * 5) + 1;
  }

  onSubmit() {
    if (!this.securityService.loading)
      this.securityService.login(
        this.form.value,
        this.callbackSuccess.bind(this),
        this.callbackError.bind(this)
      );
  }

  onRecuperaSenha() {
    if (!this.form2.valid) {
      this.error2 = true;
      return;
    }
    if (!this.securityService.loading)
      this.securityService.recuperaSenha(
        this.form2.value,
        function (resp) {
          if (resp.msg == "OK") {
            Swal.fire({
              title: $localize`Recuperando Acesso...`,
              html: $localize`<br>Aguarde alguns instantes e <b>verifique sua conta de email!</b>`,
              icon: "success",
              timerProgressBar: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: false,
              timer: 10000,
              willOpen: () => {
                Swal.showLoading();
              },
              didClose: () => {
                this.router.navigate(["/login"]).then(() => {
                  window.location.reload();
                });
              },
              padding: "3em",
              backdrop: `
              rgba(0,0,123,0.4)
              url("/assets/nyan-cat.gif")
              left top
              no-repeat
            `,
            });
          }
          $("#recuperaModal").modal("hide");
        }.bind(this),
        function (error) {
          $("#recuperaModal").modal("hide");
          Swal.fire({
            title: $localize`Recupera Acesso`,
            html: $localize`<br>Não foi possível recuperar seu acesso, aguarde alguns instantes para nova tentativa...`,
            icon: "error",
            timerProgressBar: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            timer: 10000,
          });
        }.bind(this)
      );
  }

  async callbackSuccess(resp) {
    // this.logService.userLogin(resp);
    this.initProvider.inicializaPedido = resp.inicia_pedido_selecionado;
    this.initProvider.inicializaPedidoSubject.next(
      resp.inicia_pedido_selecionado
    );
    await new Promise<void>((resolve) => {
      this.usuarioService.getClientes(
        { busca: "" },
        async (clientesUsuario) => {

          if (Array.isArray(clientesUsuario) && clientesUsuario.length === 1) {
            const clienteResp: any = await new Promise((resolveCliente) => {
              this.usuarioService.getClientesId(
                { id_cliente: clientesUsuario[0].id },
                (resp) => resolveCliente(resp)
              );
            });

            // 👇 AQUI você salva as filiais
            if (clienteResp?.filiais && Array.isArray(clienteResp.filiais)) {
              this.initProvider.filiais = clienteResp.filiais;
            } else {
              this.initProvider.filiais = [];
            }
          } else {
            this.initProvider.filiais = [];
          }

          resolve();
        }
      );
    });
    if (this.SITE.appendHeadAfterLogin)
      $("head").append(this.SITE.appendHeadAfterLogin);
  }

  callbackError(e) {
    this.error = true;
  }
}
